import { gateway } from "src/gateway";
import {
  CreateNotePayload,
  INote,
  INoteFilters,
  TogglePinNotePayload,
  UpdateNotePayload,
} from "../interfaces/notes.interface";

export const getNotesAction = async (filters: INoteFilters = {}): Promise<INote[]> => {
  try {
    const res = await gateway.get("/notes", {
      params: {
        ...(filters.clientUid ? { clientUid: filters.clientUid } : {}),
        ...(filters.jobId !== undefined && filters.jobId !== null ? { jobId: filters.jobId } : {}),
        ...(filters.jobEventUid ? { jobEventUid: filters.jobEventUid } : {}),
        ...(filters.type ? { type: filters.type } : {}),
        ...(filters.pinned !== undefined ? { pinned: filters.pinned } : {}),
      },
    });

    return res.data?.data || [];
  } catch (error) {
    console.error("Error fetching notes:", error);
    throw error;
  }
};

export const getNoteByIdAction = async (noteUid: string): Promise<INote> => {
  try {
    const res = await gateway.get(`/notes/${noteUid}`);
    return res.data?.data;
  } catch (error) {
    console.error("Error fetching note detail:", error);
    throw error;
  }
};

export const createNoteAction = async (payload: CreateNotePayload): Promise<INote> => {
  try {
    const res = await gateway.post("/notes", payload);
    return res.data?.data;
  } catch (error) {
    console.error("Error creating note:", error);
    throw error;
  }
};

export const updateNoteAction = async ({
  noteUid,
  ...data
}: UpdateNotePayload): Promise<INote> => {
  try {
    const res = await gateway.patch(`/notes/${noteUid}`, data);
    return res.data?.data;
  } catch (error) {
    console.error("Error updating note:", error);
    throw error;
  }
};

export const togglePinNoteAction = async ({
  noteUid,
  pinned,
}: TogglePinNotePayload): Promise<INote> => {
  try {
    const res = await gateway.patch(`/notes/${noteUid}/pin`, { pinned });
    return res.data?.data;
  } catch (error) {
    console.error("Error toggling note pin:", error);
    throw error;
  }
};

export const deleteNoteAction = async (noteUid: string): Promise<boolean> => {
  try {
    await gateway.delete(`/notes/${noteUid}`);
    return true;
  } catch (error) {
    console.error("Error deleting note:", error);
    throw error;
  }
};
